// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Parasitics Panel Styles
 */

.parasitics-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--color-ide-surface);
  color: var(--color-ide-text);
}

.parasitics-header {
  padding: 8px 12px;
  border-bottom: 1px solid var(--color-ide-border);
}

.parasitics-header-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-ide-text-muted);
  user-select: none;
}

.parasitics-header-ident {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
  color: var(--color-ide-text-dim);
  margin-left: 4px;
}

.parasitics-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px;
}

.parasitics-message {
  padding: 8px;
  font-size: 11px;
  color: var(--color-ide-text-dim);
}

.parasitics-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.parasitics-toggle-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s;
}

.parasitics-toggle-btn.enabled {
  background: rgba(34, 197, 94, 0.15);
  color: rgb(74, 222, 128);
}

.parasitics-toggle-btn.enabled:hover {
  background: rgba(34, 197, 94, 0.25);
}

.parasitics-toggle-btn.disabled {
  background: rgba(100, 100, 100, 0.15);
  color: var(--color-ide-text-muted);
}

.parasitics-toggle-btn.disabled:hover {
  background: rgba(100, 100, 100, 0.25);
}

.parasitics-refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: none;
  border-radius: 4px;
  background: rgba(100, 100, 100, 0.15);
  color: var(--color-ide-text-muted);
  cursor: pointer;
  transition: background-color 0.15s;
}

.parasitics-refresh-btn:hover {
  background: rgba(100, 100, 100, 0.25);
}

.parasitics-summary {
  padding: 8px;
  margin-bottom: 8px;
  background: rgba(100, 100, 100, 0.1);
  border-radius: 4px;
}

.parasitics-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  padding: 2px 0;
}

.parasitics-summary-row span:first-child {
  color: var(--color-ide-text-muted);
}

.parasitics-summary-row span:last-child {
  font-family: monospace;
  color: var(--color-ide-text);
}

.parasitics-summary-divider {
  height: 1px;
  background: var(--color-ide-border);
  margin: 6px 0;
}

.parasitics-clear-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 6px 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-ide-text-muted);
  font-size: 10px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.parasitics-clear-btn:hover {
  background: var(--color-ide-surface-hover);
}

.parasitics-section {
  margin-top: 8px;
}

.parasitics-section-header {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 6px 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-ide-text-muted);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: background-color 0.15s;
}

.parasitics-section-header:hover {
  background: var(--color-ide-surface-hover);
}

.parasitics-section-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}

.parasitics-net-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 6px 8px;
  border: none;
  border-radius: 4px;
  background: rgba(59, 130, 246, 0.08);
  cursor: pointer;
  transition: background-color 0.15s;
  text-align: left;
}

.parasitics-net-row:hover {
  background: rgba(59, 130, 246, 0.15);
}

.parasitics-net-name {
  font-size: 11px;
  font-weight: 500;
  color: rgb(147, 197, 253);
  margin-bottom: 2px;
}

.parasitics-net-stats {
  display: flex;
  gap: 12px;
  font-size: 10px;
  font-family: monospace;
  color: var(--color-ide-text);
}

.parasitics-net-details {
  font-size: 9px;
  color: var(--color-ide-text-dim);
  margin-top: 2px;
}

.parasitics-coupling-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 6px 8px;
  border: none;
  border-radius: 4px;
  background: rgba(249, 115, 22, 0.08);
  cursor: pointer;
  transition: background-color 0.15s;
  text-align: left;
}

.parasitics-coupling-row:hover {
  background: rgba(249, 115, 22, 0.15);
}

.parasitics-coupling-nets {
  font-size: 10px;
  font-weight: 500;
  color: rgb(251, 146, 60);
}

.parasitics-coupling-value {
  font-size: 10px;
  font-family: monospace;
  color: var(--color-ide-text);
}
`, "",{"version":3,"sources":["webpack://./src/components/ParasiticsPanel/parasiticsPanel.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B","sourcesContent":["/*\n * Parasitics Panel Styles\n */\n\n.parasitics-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--color-ide-surface);\n  color: var(--color-ide-text);\n}\n\n.parasitics-header {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--color-ide-border);\n}\n\n.parasitics-header-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-ide-text-muted);\n  user-select: none;\n}\n\n.parasitics-header-ident {\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: normal;\n  color: var(--color-ide-text-dim);\n  margin-left: 4px;\n}\n\n.parasitics-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 8px;\n}\n\n.parasitics-message {\n  padding: 8px;\n  font-size: 11px;\n  color: var(--color-ide-text-dim);\n}\n\n.parasitics-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.parasitics-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.parasitics-toggle-btn.enabled {\n  background: rgba(34, 197, 94, 0.15);\n  color: rgb(74, 222, 128);\n}\n\n.parasitics-toggle-btn.enabled:hover {\n  background: rgba(34, 197, 94, 0.25);\n}\n\n.parasitics-toggle-btn.disabled {\n  background: rgba(100, 100, 100, 0.15);\n  color: var(--color-ide-text-muted);\n}\n\n.parasitics-toggle-btn.disabled:hover {\n  background: rgba(100, 100, 100, 0.25);\n}\n\n.parasitics-refresh-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  border: none;\n  border-radius: 4px;\n  background: rgba(100, 100, 100, 0.15);\n  color: var(--color-ide-text-muted);\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.parasitics-refresh-btn:hover {\n  background: rgba(100, 100, 100, 0.25);\n}\n\n.parasitics-summary {\n  padding: 8px;\n  margin-bottom: 8px;\n  background: rgba(100, 100, 100, 0.1);\n  border-radius: 4px;\n}\n\n.parasitics-summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 10px;\n  padding: 2px 0;\n}\n\n.parasitics-summary-row span:first-child {\n  color: var(--color-ide-text-muted);\n}\n\n.parasitics-summary-row span:last-child {\n  font-family: monospace;\n  color: var(--color-ide-text);\n}\n\n.parasitics-summary-divider {\n  height: 1px;\n  background: var(--color-ide-border);\n  margin: 6px 0;\n}\n\n.parasitics-clear-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 6px 8px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-ide-text-muted);\n  font-size: 10px;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.parasitics-clear-btn:hover {\n  background: var(--color-ide-surface-hover);\n}\n\n.parasitics-section {\n  margin-top: 8px;\n}\n\n.parasitics-section-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  padding: 6px 8px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-ide-text-muted);\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.parasitics-section-header:hover {\n  background: var(--color-ide-surface-hover);\n}\n\n.parasitics-section-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 4px;\n}\n\n.parasitics-net-row {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 6px 8px;\n  border: none;\n  border-radius: 4px;\n  background: rgba(59, 130, 246, 0.08);\n  cursor: pointer;\n  transition: background-color 0.15s;\n  text-align: left;\n}\n\n.parasitics-net-row:hover {\n  background: rgba(59, 130, 246, 0.15);\n}\n\n.parasitics-net-name {\n  font-size: 11px;\n  font-weight: 500;\n  color: rgb(147, 197, 253);\n  margin-bottom: 2px;\n}\n\n.parasitics-net-stats {\n  display: flex;\n  gap: 12px;\n  font-size: 10px;\n  font-family: monospace;\n  color: var(--color-ide-text);\n}\n\n.parasitics-net-details {\n  font-size: 9px;\n  color: var(--color-ide-text-dim);\n  margin-top: 2px;\n}\n\n.parasitics-coupling-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 6px 8px;\n  border: none;\n  border-radius: 4px;\n  background: rgba(249, 115, 22, 0.08);\n  cursor: pointer;\n  transition: background-color 0.15s;\n  text-align: left;\n}\n\n.parasitics-coupling-row:hover {\n  background: rgba(249, 115, 22, 0.15);\n}\n\n.parasitics-coupling-nets {\n  font-size: 10px;\n  font-weight: 500;\n  color: rgb(251, 146, 60);\n}\n\n.parasitics-coupling-value {\n  font-size: 10px;\n  font-family: monospace;\n  color: var(--color-ide-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
